import React from 'react';
import { useSelector } from 'react-redux';

import SmartImage from 'dpl/components/SmartImage';
import Icon from 'dpl/common/components/Icon';
import { isLessThanBreakpoint } from 'dpl/util/grid';
import TooltipWrapper from 'dpl/common/tooltip/components/TooltipWrapper';
import { TOOLTIP_VARIANTS } from 'dpl/common/utils/constants';

import CarolineCoile from 'dpl/assets/overview_pages/caroline-coile-round.jpg';

import {
  CarolineCoileTooltipContent,
  NateRitterTooltipContent
} from './GetToKnowAuthorSectionTooltipContent';

const IS_LT_LARGE = isLessThanBreakpoint('lg');
const AVATAR_SIZE = IS_LT_LARGE ? '56px' : '64px';
const TOOLTIP_WIDTH = '392px';

export default function GetToKnowAuthorSection() {
  const { overviewPageData } = useSelector(({ server }) => server);
  return (
    <>
      <div className="flex mb6 mb10-md">
        <SmartImage
          className="br-100 mr3 mr4-md"
          width={AVATAR_SIZE}
          height={AVATAR_SIZE}
          src={CarolineCoile}
        />
        <div className="dn-ns w-80 dark-silver font-16">
          Written by{' '}
          <TooltipWrapper
            variant={TOOLTIP_VARIANTS.LIGHT}
            title={<CarolineCoileTooltipContent />}
          >
            <span className="underline">Caroline Coile, Ph.D.</span>,
          </TooltipWrapper>
          &nbsp;author of 34 dog books.{' '}
          <TooltipWrapper
            variant={TOOLTIP_VARIANTS.LIGHT}
            title={<NateRitterTooltipContent />}
          >
            <span className="underline">Veterinarian reviewed</span>
          </TooltipWrapper>
          &nbsp;by Nate Ritter, DVM.
        </div>
        <div className="dn dib-ns w-60 dark-silver font-16">
          Written by{' '}
          <TooltipWrapper
            variant={TOOLTIP_VARIANTS.LIGHT}
            title={<CarolineCoileTooltipContent />}
            minWidth={TOOLTIP_WIDTH}
          >
            <span className="underline">Caroline Coile, Ph.D.</span>,
          </TooltipWrapper>
          &nbsp;author of 34 dog books, including the top-selling Barron&apos;s
          Encyclopedia of Dog Breeds.
        </div>
      </div>
      {overviewPageData.vet_reviewed && (
        <TooltipWrapper
          variant={TOOLTIP_VARIANTS.LIGHT}
          title={<NateRitterTooltipContent />}
          minWidth={TOOLTIP_WIDTH}
        >
          <div className="dn flex-ns bg-branch-light max-content ph4 pv1 br-pill items-center">
            <Icon name="user-checked" className="branch-dark mr1" />
            <p className="branch font-16">Veterinarian reviewed</p>
          </div>
        </TooltipWrapper>
      )}
    </>
  );
}
